module.exports = __webpack_public_path__ + "static/media/img143.96f466e5.jpg";